'use strict';

/**
 * @function
 * @description
 * @param {String} url
 */
const toAbsoluteUrl = (url) => {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
        url = '/' + url;
    }
    return url;
};

module.exports = toAbsoluteUrl;
